import { Product } from '@usacsmideo/types';
import { auth } from '../../constants/firebaseModular';
import * as Sentry from '@sentry/browser';

export const getProduct = async (uid: string): Promise<Product | undefined> => {
  const url = `${import.meta.env.VITE_CLOUDFUNCTIONS_URI}/commerceApi/products/${uid}`;
  const token = await auth.currentUser?.getIdToken();
  if (!token) {
    throw new Error('User is not authenticated');
  }

  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('Authorization', `Bearer ${token}`);

  const res = await fetch(url, {
    method: 'GET',
    headers: myHeaders,
  });

  if (res.status !== 200) {
    const data = await res.json().catch(() => ({}));
    const errorMessage = data.error || 'Unable to load product information';
    Sentry.captureException(new Error(`getProduct failed: ${res.status} - ${errorMessage}`), {
      extra: { productId: uid },
    });
    throw new Error(errorMessage);
  }

  const data = await res.json();
  return data;
};
